namespace $.$$ {
	
	$mol_style_define( $hyoo_dnd_item_config, {
		
		flex: {
			basis: '40rem',
		},
		
		Body_content: {
			gap: $mol_gap.block,
		},
		
	} )
	
}
